export default {
  getters: {
    navigationSteps: () => [
      { key: 'project', label: 'Project' },
      { key: 'models', label: 'Models', disabled: true },
      { key: 'api', label: 'API', disabled: true },
      { key: 'devops', label: 'DevOps', disabled: true },
    ],
  },
  mutations: {
    updatModel() {},
  },
};
